import React from "react";
import { CARE_WATCH_VIEWS } from "../utils/constants";

const CareWatchPageSubtitle = ({ view }) => (
  <span className="care-watch-page-desc">
    {view === CARE_WATCH_VIEWS.LIVE
      ? "Watch in-progress shifts, late clock-ins, and shifts still running after the scheduled end."
      : "Review AI-detected signals in submitted timesheet shift notes and triage follow-up before incidents are missed."}
  </span>
);

export default CareWatchPageSubtitle;
